import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "Facebook Data Deletion" }) => {
  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{headingText}</Heading>
          </HeadingRow>
          <Text>
            <p>Last updated: August 8, 2024</p>

            <p>
              In accordance with Facebook's App and Website Platform rules, we
              will provide a user data deletion callback URL or data deletion
              instructions URL. If you wish to delete your activity on the
              "Baseball GOAT" application, you can follow these steps:
            </p>

            <br />

            <ul>
              <li>
                <p>
                  Go to <strong>"Settings & Privacy"</strong> in your Facebook
                  account, then click on <strong>"Settings"</strong>.
                </p>
              </li>
              <li>
                <p>
                  Find <strong>"Apps and Websites"</strong>, where you will see
                  all the apps and websites linked to your Facebook account.
                </p>
              </li>
              <li>
                <p>
                  Search for and click on <strong>"Baseball GOAT"</strong> in
                  the search bar.
                </p>
              </li>
              <li>
                <p>
                  Check the option boxes according to your preferences, then
                  click the <strong>"Remove"</strong> button.
                </p>
              </li>
              <li>
                <p>
                  Congratulations! You have successfully deleted the app
                  activity :)
                </p>
              </li>
            </ul>
          </Text>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
